import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/collection/01/thumbnail.jpg'

const paperInfo = {
  paperName: 'commmune活用事例集',
  enPaperName: 'caseStudy-Collection',
  thumbnail: thumbnail,
  feature1: 'commmuneを導入いただく前にお客様が抱えていた課題',
  feature2: 'commmuneの活用方法と得られた成果',
  feature3: 'commmuneを導入いただいたお客様の生の声',
  description:
    'commmuneをご利用いただいているお客様の活用方法をまとめてご覧になれる事例です。お客様の課題や目的ごとにどのような活用方法があるのか、どのような成果を得られているのか、理解が深まる資料です。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-01-17/bnnf1',
  type: 'pardot'
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
